import React from "react";
import ReactGA from "react-ga";
import {Link, withRouter} from "react-router-dom";
import styled from "@emotion/styled";
import Routes from "../Routes";

const Ul = styled.ul`
  display: flex;
`;

const Li = styled.li`
  font-size: 1rem;
  letter-spacing: 0.1rem;
  margin-right: 20px;
  > a {
    color: rgba(255, 255, 255, 0.5);
    transition: all .2s;
    /* @media screen and (max-width: 1024px) {
      
    } */
  }
  &:last-child {
    margin-right: 0;
  }
`;

const Menu = (props) => {
  const { pathname} = props.location;
  return (
    <Ul>
      {Routes.map((i, k) => {
        const {path, text} = i;
        return (
          k < 2 ?
          <Li key={k}>
            <Link
              onClick={props.handleClose}
              to={path}
              style={{color: pathname === path  ? 'rgba(255, 255, 255, 1)' : pathname.indexOf('case') !== -1 ? k === 0 && 'rgba(255, 255, 255, 1)' : ''}}
              onClick={()=>{
                ReactGA.event({
                  category: "202012_PRADO",
                  action: "Click",
                  label: `Menu-${text}`,
                });
              }}
            >
              {text}
            </Link>
          </Li>
          :
          ''
        )
      })}
      <Li>
        <a href="https://www.toyota.com.tw/showroom/PRADO" target="_blank" rel="noreferrer" onClick={()=>{
          ReactGA.event({
            category: "202012_PRADO",
            action: "Click",
            label: `Menu-深入了解PRADO`,
          });
        }}>深入了解PRADO</a>
      </Li>
      <Li>
        <a href="http://www.wildonetaiwan.org/" target="_blank" rel="noreferrer" onClick={()=>{
          ReactGA.event({
            category: "202012_PRADO",
            action: "Click",
            label: `Menu-臺灣野灣野生動物保育協會`,
          });
        }}>臺灣野灣野生動物保育協會</a>
      </Li>
    </Ul>
  )
};

export default withRouter(Menu);